/* =================== CARROSSEL PRUDUTOS =================== */
$(function () {
  $(".carrosel-solucoes").slick({
    slidesToShow: 3,
    slidesToScroll: 3,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 760,
        settings: "unslick",
      },
    ],
  });
});
